import React, { createContext, useContext, useState, useCallback } from 'react';
import './ConfirmDialog.css';

const ConfirmDialogContext = createContext(null);

export function ConfirmDialogProvider({ children }) {
  const [dialog, setDialog] = useState(null);

  const confirm = useCallback(({ title, message, confirmLabel = 'Confirm', cancelLabel = 'Cancel', variant = 'danger' }) => {
    return new Promise((resolve) => {
      setDialog({ title, message, confirmLabel, cancelLabel, variant, resolve });
    });
  }, []);

  const handleConfirm = () => {
    dialog?.resolve(true);
    setDialog(null);
  };

  const handleCancel = () => {
    dialog?.resolve(false);
    setDialog(null);
  };

  return (
    <ConfirmDialogContext.Provider value={{ confirm }}>
      {children}
      {dialog && (
        <div className="pms-confirm-overlay" onClick={handleCancel} role="dialog" aria-modal="true" aria-labelledby="confirm-title">
          <div className="pms-confirm-box" onClick={e => e.stopPropagation()}>
            <div className={`pms-confirm-icon pms-confirm-icon-${dialog.variant}`}>
              {dialog.variant === 'danger' ? (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
                  <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
              ) : (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="16" x2="12" y2="12"/>
                  <line x1="12" y1="8" x2="12.01" y2="8"/>
                </svg>
              )}
            </div>
            <div className="pms-confirm-content">
              <h3 id="confirm-title" className="pms-confirm-title">{dialog.title}</h3>
              <p className="pms-confirm-message">{dialog.message}</p>
            </div>
            <div className="pms-confirm-actions">
              <button className="pms-btn pms-btn-secondary" onClick={handleCancel}>
                {dialog.cancelLabel}
              </button>
              <button
                className={`pms-btn ${dialog.variant === 'danger' ? 'pms-btn-danger' : 'pms-btn-primary'} pms-confirm-ok`}
                onClick={handleConfirm}
                autoFocus
              >
                {dialog.confirmLabel}
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmDialogContext.Provider>
  );
}

export function useConfirm() {
  const ctx = useContext(ConfirmDialogContext);
  if (!ctx) throw new Error('useConfirm must be used inside ConfirmDialogProvider');
  return ctx.confirm;
}
